<template>

<div class="image" v-lazy:background-image="image" :data-size="field.size" :style="style" v-on:click="onAvatarClick" v-tooltip="'Click to see more details'">

    <core-rating :value="rating" class="image-box rating" v-if="showRating" />

	<div class="image-box date" v-if="showDate">

   	 	<core-date :date="date" theme="white" />

	</div>

	<div class="image-box plays" v-if="showPlays">{{ plays }}</div>

</div>

</template>

<script>

export default {

	props: ['field', 'item'],

    computed: {

		rating: function() {

			return (this.isUser) ? this.item.user.rating_avg : this.item.group.rating_avg

		},

		plays: function() {

			return (this.isUser) ? this.item.user.plays : this.item.users.totalPlays

		},

		date: function() {

			return this.item.play.date

		},

        image: function() {

            return this.$util.thumbnail.game[(this.field.size === 'natural') ? 'natural' : 'medium'](this.item.game)

        },

		showRating: function() {

			return this.field.rating === 'enabled'

		},

		showPlays: function() {

			return this.field.plays === 'enabled'

		},

		showDate: function() {

			return this.field.date === 'enabled' && this.isUser

		},

        style: function() {

            var style = {}

            if (this.field.size === 'square') {

                style.borderRadius = this.field.radius.toString() + '%'

            }

            return style

        }

    },

	methods: {

		onAvatarClick: function(e) {

			if (e.shiftKey) {

				this.$util.bgg.open.game(this.item.game.id)

			} else {

				this.$pubsub.$emit('expand.open', {
					id: this.item.game.id
				})

			}

		}

	}

}

</script>

<style scoped>

.image {
	width: 160px;
	height: 160px;
	background-position: 50% 50%;
    background-repeat: no-repeat;
	cursor: pointer;
}

.is-mobile .image {
	width: 140px;
	height: 140px;
}

.image[data-size="natural"] {
	background-size: contain;
}

.image[data-size="square"] {
	background-size: cover;
}

.image-box {
	position: absolute;
	left: 50%;
	bottom: 0px;
	margin-left: -24px;
	width: 48px;
	height: 48px;
	line-height: 48px;
	border: 2px solid #fff;
	border-bottom: 0px;
	text-align: center;
	line-height: 46px;
	color: #fff;
	font-size: 16px;
	font-weight: 500;
}

.image-box.date {
	display: flex;
	align-items: center;
	justify-content: center;
}

.image-box.date,
.image-box.plays {
	background-color: #2b5870;
}

</style>